/**
 * excel å¯¼åº header modal
 */
export class SheetHeaderModal {

  /**
   * åå
   */
  name: string;

  /**
   * ååæ è¯
   */
  filedName?: string;

  /**
   * ç±»å
   */
  type?: string;

  constructor(name: string, filedName?: string, type?: string) {
    this.filedName = filedName;
    this.name = name;
    this.type = type;
  }

}
